module.exports = __webpack_public_path__ + "static/media/iconoBuscar.d36f3e70.svg";